// extracted by mini-css-extract-plugin
module.exports = {"previewPanel":"PreviewPanel_previewPanel__aYgft"};